module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-en-2cd918449e6199e61b100e8d9bfa6ded.svg";